import React, { useEffect, useState } from "react";
import { db } from "../FirebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const DigitalSkills = () => {
  const [mentors, setMentors] = useState([]);
  const [loading, setLoading] = useState(true);

  console.log("mentor", mentors)
  // Fetch mentors data from Firestore
  useEffect(() => {
    const fetchMentors = async () => {
      try {
        setLoading(true);
        const querySnapshot = await getDocs(collection(db, "courses"));
        const mentorsData = querySnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((mentor) => mentor.status === "approved");
        setMentors(mentorsData);
      } catch (error) {
        console.error("Error fetching mentors: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMentors();
  }, []);

  return (
    <>
      <Header />
      <section className="relative flex justify-center items-center bg-gradient-to-r from-black to-logo text-white md:py-24 py-12 w-full overflow-hidden">
        <div className="flex flex-col justify-center items-center text-center">
          <h2 className="md:text-5xl text-2xl font-bold animate-fadeIn">
            Digital Skills Program
          </h2>
          <p className="md:w-[70%] p-3">
            Digital Skills Program is launched by AS-Tech Community to make
            un-skilled individuals learn skills and become able to earn money.
            Our mentors make sure to teach in-depth skills to all enrolled
            students.
          </p>
        </div>
      </section>
      <div className="relative container w-full mx-auto md:px-24 px-6 md:py-6 py-3 md:mb-0 mb-32">
        {loading ? (
          <div className="grid md:grid-cols-3 grid-cols-1 gap-6 mt-8">
            {Array(12)
              .fill()
              .map((_, index) => (
                <div
                  key={index}
                  className="border rounded-lg shadow-xl p-4 text-center transition-all duration-500 ease-in-out transform hover:-translate-y-2 bg-white flex flex-col"
                >
                  {/* Skeleton Image */}
                  <div className="w-full h-60 bg-gray-300 animate-pulse mb-4"></div>
                  {/* Skeleton Text (Course Name and Mentor Name) */}
                  <div className="w-3/4 h-6 mx-auto bg-gray-300 animate-pulse mb-4"></div>
                  {/* Skeleton Price */}
                  <div className="flex gap-3 items-center mb-2">
                    <div className="w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
                    <div className="w-1/2 h-5 bg-gray-300 animate-pulse"></div>
                  </div>
                  {/* Skeleton Duration */}
                  <div className="flex gap-3 items-center mb-4">
                    <div className="w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
                    <div className="w-1/2 h-5 bg-gray-300 animate-pulse"></div>
                  </div>
                  {/* Skeleton See More Button */}
                  <div className="w-full h-10 mx-auto bg-gray-300 rounded-full animate-pulse mt-auto"></div>
                </div>
              ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-3 grid-cols-1 gap-6 mt-8">
            {mentors.map((mentor, index) => (
              <div
                key={index}
                className="border rounded-lg shadow-xl p-4 text-center transition-all duration-500 ease-in-out transform hover:-translate-y-2 bg-white flex flex-col"
              >
                <Link to={`/mentor/${mentor.id}`} className="flex flex-col flex-grow">
                  <img
                    src={mentor.pictureUrl}
                    alt={mentor.name}
                    className="w-full h-[300px] mb-4 object-cover"
                  />
                  <p className="px-3 text-xl text-start text-gray-800 min-h-[4rem]">
                    Join the acclaimed{" "}
                    <span className="text-orange-500 font-semibold">
                      "{mentor.coursename}"
                    </span>{" "}
                    course by expert mentor{" "}
                    <span className="font-semibold">{mentor.name}</span>
                  </p>
                  <div className="flex flex-col px-3 mt-6 mb-4">
                    <h3 className="text-lg font-bold flex gap-3 items-center min-h-[2rem]">
                      <img
                        src={require("../assets/images/price-tag.png")}
                        alt="Price tag"
                        className="w-6 h-6"
                      />
                      {mentor.charges}
                    </h3>
                    <h3 className="text-lg flex gap-3 items-center min-h-[2rem]">
                      <img
                        src={require("../assets/images/date.png")}
                        alt="Duration"
                        className="w-6 h-6"
                      />
                      {mentor.duration}
                    </h3>
                  </div>
                  <button
                    className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg mt-auto"
                    aria-label={`See more about ${mentor.coursename} by ${mentor.name}`}
                  >
                    See More
                  </button>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default DigitalSkills;